import React from "react";
import { GlobalProvider } from "./context/global-context";

export function GlobalFactory({ children }: { children: React.ReactNode }) {

    return (
        <GlobalProvider>
                {children}
        </GlobalProvider>
    );
}